import { Dispatch } from "@reduxjs/toolkit";
import { ModalId } from "../../../enums/modalId";
import { setOpenedModalId } from "../../../redux/slice/modalSliceNew";

/**
 * Handler for the Add/Edit button in the Calling Worklist table.
 * Opens the non-EPA modal with row data.
 *
 * @input dispatch - Redux dispatch
 * @input rowData - Raw order row the modal should open for
 */
export const handleOpenSubmissionSummary = (
  dispatch: Dispatch,
  rowData: any,
) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.NON_EPA_MODAL,
      metaData: {
        data: rowData,
      },
    }),
  );
};

/**
 * Handler for the history icon in the Calling Worklist table.
 * Opens the read-only non-EPA history side panel with row data.
 *
 * @input dispatch - Redux dispatch
 * @input rowData - Raw order row the panel should open for
 */
export const handleOpenNonEpaHistory = (dispatch: Dispatch, rowData: any) => {
  dispatch(
    setOpenedModalId({
      id: ModalId.NON_EPA_HISTORY_PANEL,
      metaData: {
        data: rowData,
      },
    }),
  );
};
